import React, { Component } from "react";

import { connect } from "react-redux";
import { server, getFilledCollection } from "redux-server-connection";
import urls from "../../reducers/urls";

import Render from "./Render";

class DesafiosPanel extends Component {
  componentWillMount() {
    if (typeof window !== "undefined") {
      this.props.getTrainings();
    }
  }

  render() {
    return <Render {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    trainings: getFilledCollection(state.trainings, urls.trainings.list)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTrainings: () => dispatch(server.get(urls.trainings.list, "TRAININGS"))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DesafiosPanel);



// WEBPACK FOOTER //
// ./src/pages/DesafiosPanel/index.js